module.exports = __webpack_public_path__ + "img/templates_active.14b9c336.svg";